import axios from 'axios';
import React from 'react'

export function GetTags(dispatch) {
  axios.get("/api/etiquetas").then(tags => {
    dispatch({ type: "tagsListado", tags });
  }).catch(e => console.error(e))
}